export const ASR_SETTINGS_SLICE_NAME = 'asrSettings';
